/* This example requires Tailwind CSS v2.0+ */
import { RadioGroup } from '@headlessui/react';
import useLocale from 'next-translate/useTranslation';
import { useState } from 'react';
import { RadioOption } from 'types';

import clsxm from '@/lib/clsxm';

interface RadioGroupProps {
  options: RadioOption[];
  onChange: (value: string) => void;
}

export default function RadioCards({ options, onChange }: RadioGroupProps) {
  const checkedOption = options.find((m) => m.checked);
  const { t } = useLocale('tools');

  const [value, setValue] = useState(checkedOption);

  return (
    <div>
      <RadioGroup
        value={value}
        onChange={(option: any) => {
          option.checked = true;
          setValue(option);
          onChange(option.name);
        }}
        className='mt-2'
      >
        <div className='grid grid-cols-3 gap-3 sm:grid-cols-3'>
          {options.map((option) => (
            <RadioGroup.Option
              key={option.name}
              value={option}
              className={({ active, checked }) =>
                clsxm(
                  active ? 'ring-1 ring-primary-500 ring-offset-1' : '',
                  value?.checked && value?.name === option.name
                    ? 'border-transparent bg-primary-600 text-white hover:bg-primary-700 dark:text-slate-300'
                    : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50 dark:border-white/5 dark:bg-slate-700/50 dark:text-slate-400',
                  'flex cursor-pointer items-center justify-center rounded-md border px-1 py-1 text-sm font-medium  sm:flex-1'
                )
              }
            >
              <RadioGroup.Label as='span'>{t(option.name)}</RadioGroup.Label>
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
